import { styled } from '@mui/material'

export const BannerContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => theme.spacing(0, 2.5)};
  max-width: ${({ theme }) => theme.spacing(50)};
`

export const IllustrationContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSmallScreen' && prop !== 'isSizeSmall',
})<{ isSmallScreen?: boolean; isSizeSmall?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ isSmallScreen, theme, isSizeSmall }) =>
    isSmallScreen ? theme.spacing(isSizeSmall ? 18.75 : 25) : theme.spacing(50)};
  height: ${({ isSmallScreen, theme, isSizeSmall }) =>
    isSmallScreen ? theme.spacing(isSizeSmall ? 18.75 : 25) : theme.spacing(50)};
`
